// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"_3flZM","separator":"_1635G","listContainer":"_3luxJ"};